import * as React from "react";
import * as SeparatorPrimitive from "@radix-ui/react-separator";

import { cn } from "@/lib/utils";

const Separator = React.forwardRef<
  React.ElementRef<typeof SeparatorPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SeparatorPrimitive.Root> & {
    text?: string;
  }
>(
  (
    {
      className,
      orientation = "horizontal",
      decorative = true,
      text,
      ...props
    },
    ref
  ) => (
    <div className={cn("flex items-center", className)}>
      <SeparatorPrimitive.Root
        ref={ref}
        decorative={decorative}
        orientation={orientation}
        className={cn(
          "shrink-0 bg-border",
          orientation === "horizontal" ? "h-[1px] flex-grow" : "h-full w-[1px]"
        )}
        {...props}
      />
      {text && (
        <>
          <span className="px-2 text-sm text-muted-foreground">{text}</span>
          <SeparatorPrimitive.Root
            decorative={decorative}
            orientation={orientation}
            className={cn(
              "shrink-0 bg-border",
              orientation === "horizontal"
                ? "h-[1px] flex-grow"
                : "h-full w-[1px]"
            )}
          />
        </>
      )}
    </div>
  )
);
Separator.displayName = SeparatorPrimitive.Root.displayName;

export { Separator };
